module.exports = __webpack_public_path__ + "img/edi-5.6741dd95.png";